import type { Candidate, Dossier } from "./types";

const s = (id: string, label: string, text: string): Candidate => ({
  id,
  kind: "statute",
  label,
  text,
});

const c = (id: string, label: string, text: string): Candidate => ({
  id,
  kind: "case",
  label,
  text,
  meta: "판례 원문 발췌",
});

export const FIXTURE_QUERY =
  "집주인이 전세보증금을 돌려주지 않고 계약갱신도 거절합니다. 임차인으로서 어떤 조문과 판례를 봐야 하나요?";

export const EXAMPLES = [
  "전세보증금을 못 받았는데 임차권등기가 필요한가요?",
  "상가 임대차 계약갱신을 거절당했습니다.",
  "임대인이 보증금을 반환하지 않을 때 내용증명은 어떻게 쓰나요?",
];

const statutePair1 = s(
  "s-p1",
  "주택임대차보호법 제3조의2",
  "제3조의2(보증금의 우선변제) ① 임차인은 보증금 중 일정액을 다른 담보물권자보다 우선하여 변제받을 권리가 있다. ② 임차인이 우선변제를 받으려면 임대차 계약을 체결하고 임차할 목적으로 주민등록을 마쳐야 한다. ③ 우선변제를 받을 수 있는 보증금의 범위는 대통령령으로 정한다.",
);

const statutePair2 = s(
  "s-p2",
  "주택임대차보호법 제6조의3",
  "제6조의3(계약갱신 요구 등) ① 임대인은 임차인의 계약갱신 요구를 정당한 사유 없이 거절하지 못한다. ② 임차인은 임대차기간이 끝나기 6개월 전부터 2개월 전까지 계약갱신을 요구할 수 있다. ③ 제1항에도 불구하고 임대인이 목적 주택에 실제 거주하려는 경우 등 대통령령으로 정하는 사유가 있으면 거절할 수 있다.",
);

const statutePair3 = s(
  "s-p3",
  "민법 제618조",
  "제618조(임대차의 의의) 임대차는 당사자 일방이 상대방에게 목적물을 사용·수익하게 할 것을 약정하고 상대방이 이에 대하여 차임을 지급할 것을 약정함으로써 그 효력이 생긴다.",
);

const casePair1 = c(
  "c-p1",
  "대법원 2019다12345",
  "【이유】 주택임대차보호법 제3조의2가 정한 우선변제권은 임차인이 주택의 인도와 주민등록을 마친 때에 발생한다. 임차인이 보증금 전액을 우선변제받기 위해서는 배당요구 등 법이 정한 절차를 이행하여야 하며, 임대인의 반환거절만으로 곧바로 우선변제권이 확정되는 것은 아니다.",
);

const casePair2 = c(
  "c-p2",
  "대법원 2021다23456",
  "【이유】 임대차 계약갱신 요구권은 임차인이 법정 기간 내에 의사표시를 함으로써 행사된다. 임대인이 실제 거주를 이유로 갱신을 거절하려면 그 사유를 구체적으로 주장·증명하여야 하며, 단순히 보증금을 인상하고 싶다는 사정만으로는 정당한 사유에 해당하지 않는다.",
);

const casePair3 = c(
  "c-p3",
  "서울고등법원 2020나98765",
  "【이유】 임대차기간이 만료된 후 임차인이 계속 거주하고 임대인이 이의 없이 차임을 수령한 경우에는 묵시적으로 임대차가 갱신된 것으로 본다. 다만 갱신된 임대차의 기간은 민법 제639조에 따라 정하여지며, 당사자가 언제든지 해지통고를 할 수 있는 경우에는 그 통고 후 3개월이 지나야 효력이 생긴다.",
);

const statuteList = [
  s(
    "s-1",
    "주택임대차보호법 제3조",
    "제3조(대항력 등) ① 임대차는 그 등기가 없는 경우에도 임차인이 주택의 인도와 주민등록을 마친 때에는 그 다음 날부터 제3자에 대하여 효력이 생긴다. ② 임차인이 주택의 인도와 주민등록을 마친 후 그 사실을 임대인에게 통지한 때에는 그 때부터 제3자에 대하여 효력이 생긴다.",
  ),
  s(
    "s-2",
    "주택임대차보호법 제4조",
    "제4조(임대차기간 등) ① 기간을 정하지 아니하거나 2년 미만으로 정한 임대차는 그 기간을 2년으로 본다. 다만 임차인은 2년 미만으로 정한 기간을 유지할 것을 주장할 수 있다. ② 임대차기간이 끝난 경우에도 임차인이 보증금을 반환받을 때까지는 임대차관계가 존속되는 것으로 본다.",
  ),
  s(
    "s-3",
    "민법 제623조",
    "제623조(임대인의 의무) 임대인은 목적물을 임차인에게 인도하고 계약 존속 중 그 사용·수익에 필요한 상태를 유지하게 할 의무를 부담한다.",
  ),
  s(
    "s-4",
    "민법 제640조",
    "제640조(차임 연체와 해지) 건물, 토지 또는 유동물의 임대차에 있어서 임차인이 2기의 차임액에 해당하는 금액을 연체한 때에는 임대인은 계약을 해지할 수 있다.",
  ),
  s(
    "s-5",
    "주택임대차보호법 제6조의2",
    "제6조의2(묵시적 갱신) 제6조제1항의 기간이 끝난 후 임차인이 보증금을 반환받지 아니하고 계속 점유하는 경우에는 임대차기간이 끝난 때에 제6조제1항의 기간으로 다시 임대차한 것으로 본다.",
  ),
];

const caseList = [
  c(
    "c-1",
    "대법원 2018다11111",
    "【이유】 임차인이 주민등록을 마친 뒤 임대인에게 그 사실을 통지하지 않았더라도, 임대인이 이미 그 사실을 알고 있었다면 대항력 취득 시점에 관한 제3조 제2항의 통지는 별도로 요구되지 않는다.",
  ),
  c(
    "c-2",
    "대법원 2022다22222",
    "【이유】 임대차기간 만료 후 임차인이 보증금을 반환받지 못한 상태에서 계속 점유한 경우에는 임대차관계가 존속되는 것으로 보아야 하며, 임대인이 일방적으로 명도를 요구할 수 없다.",
  ),
  c(
    "c-3",
    "서울중앙지방법원 2019가합33333",
    "【이유】 임대인이 갱신 거절의 정당한 사유를 입증하지 못한 채 계약갱신을 거부한 경우, 임차인은 갱신된 임대차관계의 존속을 주장할 수 있다. 다만 그 사유의 존부는 거절 당시를 기준으로 판단한다.",
  ),
  c(
    "c-4",
    "부산고등법원 2020나44444",
    "【이유】 임차인이 2기 이상의 차임을 연체하였다는 사정만으로 곧바로 계약이 해지되는 것은 아니며, 임대인의 해지 통고가 임차인에게 도달한 때에 계약관계가 종료된다.",
  ),
  c(
    "c-5",
    "대법원 2017다55555",
    "【이유】 임대인의 보증금 반환의무와 임차인의 목적물 반환의무는 동시이행의 관계에 있으므로, 임대인이 보증금을 반환하지 않는 동안 임차인은 목적물을 계속 점유할 수 있다.",
  ),
];

export const FIXTURE_DOSSIER: Dossier = {
  query: FIXTURE_QUERY,
  pairs: [
    { id: "p1", statute: statutePair1, case: casePair1 },
    { id: "p2", statute: statutePair2, case: casePair2 },
    { id: "p3", statute: statutePair3, case: casePair3 },
  ],
  statutes: statuteList,
  cases: caseList,
};
